export default __webpack_public_path__ + "static/media/seema-main-image-1.05cefab4.jpeg";